import { createFileRoute, useNavigate, useRouter } from '@tanstack/react-router'
import CreateReport from '../../../../../../containers/Reports/components/CreateReport'

function CreateReportWrapper() {
  const navigate = useNavigate()

  const router = useRouter()
  const { projectId } = Route.useParams()

  const handleClosePopup = () => {
    router.history.canGoBack()
      ? router.history.back()
      : navigate({ to: `/project/${projectId}/reports` })
  }

  return (
    <CreateReport
      projectId={projectId}
      closePopup={handleClosePopup}
      isCreateReportView={true}
    />
  )
}

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/reports/newReport/'
)({
  component: CreateReportWrapper
})
